export enum TemplateSizeType {
  resolution_1200x675 = 1,
  resolution_1080x1080 = 2,
  resolution_1080x1350 = 3,
  resolution_1080x608 = 4,
  resolution_1200x628 = 5,
}
